'use strict';

/**
 * Created by jcrid01 on 3/2/16.
 */
var Promise = require('bluebird');

module.exports = {
    //this helps me write unit tests for navigator without having to stub global, window, etc.:
    _navigator: typeof navigator != 'undefined' ? navigator : false,
    getCurrentPosition: function getCurrentPosition(opts) {
        var self = this;
        if (this._navigator) {
            return new Promise(function (resolve, reject) {
                self._navigator.geolocation.getCurrentPosition(resolve, reject, opts);
            });
        }
        return Promise.reject('Navigator does not exist.');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/geo.js
// module id = 848
// module chunks = 0